module.exports = __webpack_public_path__ + "static/media/eli_capiluoto.fb25c402.png";